import { Link } from "react-router-dom";

const features = [
  {
    title: "Reactive Story Engine",
    description: "Narration, board state, and action pressure evolve in lockstep instead of disconnected turns.",
  },
  {
    title: "Campaign Command Deck",
    description: "Launch sessions, inspect continuity, and recover broken state from one operations surface.",
  },
  {
    title: "Tactical Live Board",
    description: "Town, travel, dungeon, and combat transitions keep world hooks and objectives coherent.",
  },
];

const stats = [
  { label: "Active worlds", value: "120+" },
  { label: "Characters", value: "3.4k" },
  { label: "Sessions", value: "980+" },
];

export default function LandingScreen() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="mx-auto w-full max-w-6xl px-4 pb-12 pt-6 sm:px-6 sm:pt-10">
        <div className="cinematic-shell px-5 py-5 sm:px-8 sm:py-8">
          <header className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <div className="cinematic-title text-xl font-semibold text-amber-100 sm:text-2xl">Saga Spark</div>
              <div className="cinematic-subtitle text-xs">Dark-fantasy campaign runtime</div>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <Link className="cinematic-button-ghost rounded-full px-4 py-2" to="/login">
                Log in
              </Link>
              <Link className="cinematic-button-primary rounded-full px-4 py-2 font-semibold" to="/signup">
                Start free
              </Link>
            </div>
          </header>

          <section className="mt-8 grid gap-6 lg:grid-cols-[1.25fr_0.75fr] lg:items-stretch">
            <div className="space-y-4">
              <p className="text-[11px] uppercase tracking-[0.24em] text-amber-200/80">Cinematic tabletop runtime</p>
              <h1 className="cinematic-title text-4xl font-semibold leading-tight text-amber-50 sm:text-5xl">
                Forge a world that remembers what your party does.
              </h1>
              <p className="max-w-2xl text-base text-slate-200/90 sm:text-lg">
                Saga Spark keeps narration, combat, rewards, and world continuity synchronized so each turn has lasting weight.
              </p>
              <div className="flex flex-wrap gap-3 pt-1">
                <Link className="cinematic-button-primary rounded-full px-6 py-3 font-semibold" to="/signup">
                  Create your campaign
                </Link>
                <Link className="cinematic-button-ghost rounded-full px-6 py-3" to="/login">
                  Continue existing run
                </Link>
              </div>
            </div>

            <aside className="cinematic-panel p-4 sm:p-5">
              <div className="text-xs uppercase tracking-[0.18em] text-amber-100/70">Current Pulse</div>
              <div className="mt-2 text-2xl font-semibold text-amber-50">The Emberwild Arc</div>
              <div className="text-sm text-slate-300/90">Next session Friday at 8:00 PM</div>
              <div className="mt-4 grid gap-2">
                {stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="rounded-xl border border-slate-300/12 bg-slate-100/5 px-3 py-2"
                  >
                    <div className="text-[11px] uppercase tracking-wide text-slate-300/80">{stat.label}</div>
                    <div className="text-lg font-semibold text-amber-50">{stat.value}</div>
                  </div>
                ))}
              </div>
            </aside>
          </section>

          <section className="mt-7 grid gap-3 md:grid-cols-3">
            {features.map((feature) => (
              <article key={feature.title} className="cinematic-panel p-4">
                <h2 className="cinematic-title text-base font-semibold text-amber-100">{feature.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-200/85">{feature.description}</p>
              </article>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
}
